/** Axios request timeout (30 seconds) */
export const API_TIMEOUT = 30_000;

/** Short stale time for frequently changing data (30 seconds) */
export const STALE_TIME_SHORT = 1000 * 30;

/** Medium stale time for moderately changing data (2 minutes) */
export const STALE_TIME_MEDIUM = 1000 * 60 * 2;

/** Long stale time for rarely changing data (5 minutes) */
export const STALE_TIME_LONG = 1000 * 60 * 5;

/** Garbage collection time for cached data (5 minutes) */
export const GC_TIME_DEFAULT = 1000 * 60 * 5;
